// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  t478 (26-oct-2026) · EL NÚMERO DE CONSULTAS DE SOPORTE QUE ESPERAN AL EQUIPO, EN EL MENÚ Y ARRIBA DEL PANEL
// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño pasa a una cuenta SOLO de plataforma: en Superadmin tiene que ver de un vistazo cuántas consultas le esperan.
//  Quien pregunta al servidor es uno solo, el aviso llamativo (components/AvisoSoporteNuevo, cada 15 segundos, con la
//  sección «soporte»): cada vez que sabe cuántas hay lo ANUNCIA aquí, y el panel (components/PlataformaLayout) lo pinta en la
//  entrada «Consultas» del menú y en la cabecera. Sin preguntar dos veces lo mismo, y sin la sección no se anuncia nada (cero).
//  Util SIN imports (tampoco React: el panel guarda el número en su propio estado y se apunta aquí con `escucharSoportePendientes`),
//  para que lo carguen de verdad las guardias que montan el panel, con el React que sea.

export const EVENTO_PENDIENTES = 'biango:soporte-pendientes'
let _ultimo = { n: 0, urgentes: 0 }

// Lo anuncia quien lo sabe (AvisoSoporteNuevo). `n`: consultas que esperan con algo sin leer; `urgentes`: cuántas de ellas
// dicen que es urgente o piden asistencia remota.
export function anunciarSoportePendientes(n, urgentes = 0) {
  const v = { n: Math.max(0, Number(n) || 0), urgentes: Math.max(0, Number(urgentes) || 0) }
  _ultimo = v
  try {
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
      window.dispatchEvent(new CustomEvent(EVENTO_PENDIENTES, { detail: v }))
    }
  } catch (_) { /* sin eventos: el número se lee al volver a pintar */ }
}

export function soportePendientesAhora() { return _ultimo }

// Apuntarse a los anuncios (quien pinta el número): `fn({ n, urgentes })` con cada uno. Devuelve cómo darse de baja.
export function escucharSoportePendientes(fn) {
  if (typeof fn !== 'function' || typeof window === 'undefined' || typeof window.addEventListener !== 'function') return () => {}
  const oir = (e) => { const d = (e && e.detail) || {}; fn({ n: Math.max(0, Number(d.n) || 0), urgentes: Math.max(0, Number(d.urgentes) || 0) }) }
  window.addEventListener(EVENTO_PENDIENTES, oir)
  return () => window.removeEventListener(EVENTO_PENDIENTES, oir)
}
